module.exports = __webpack_public_path__ + "static/media/forest-crossroads-off.5889de96.png";